import React from 'react';
import { Link } from 'react-router-dom';
import { ago } from '../../components/three/ecosystemState';

const usd = (v) => (v == null || !Number.isFinite(Number(v)) ? '—' : `$${Number(v).toFixed(2)}`);

export function IncidentsBoard({ incidents = [] }) {
  return (
    <div className="cs-plan-tablewrap">
      <table>
        <thead><tr><th>App</th><th>Status</th><th>Opened</th><th>Reason</th><th>Brain</th></tr></thead>
        <tbody>
          {incidents.map((i) => (
            <tr key={i.id}>
              <td>{i.slug}</td><td>{i.status}</td><td>{ago(i.openedAt)}</td><td>{i.reason || '—'}</td>
              {/* Lessons/runbooks the reason matched when the incident opened (shared/brainInbox.js attachRelatedBrain). */}
              <td>{i.relatedBrain?.length ? i.relatedBrain.map((r, k) => <React.Fragment key={r.slug}>{k ? ', ' : ''}<Link to={`/admin/brain/page/${r.slug}`}>{r.title}</Link></React.Fragment>) : <span className="cs-help">—</span>}</td>
            </tr>
          ))}
          {!incidents.length && <tr><td colSpan={5} className="cs-help">No incidents.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export function HostsBoard({ hosts = [] }) {
  return (
    <div className="cs-plan-tablewrap">
      <table>
        <thead><tr><th>Host</th><th>Status</th><th>Apps</th><th>Mem</th><th>Disk</th><th>Region</th></tr></thead>
        <tbody>
          {hosts.map((h) => (
            <tr key={h.id}>
              <td className="live-mono">{h.id}</td>
              <td>{h.status}</td>
              <td>{h.count}/{h.capacity}</td>
              <td>{h.memUsedPct != null ? `${h.memUsedPct}%` : '—'}</td>
              <td>{h.diskPct != null ? `${h.diskPct}%` : '—'}</td>
              <td>{h.region}</td>
            </tr>
          ))}
          {!hosts.length && <tr><td colSpan={6} className="cs-help">No hosts reported.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export function StandbyBoard({ standby }) {
  if (!standby) return <p className="cs-help">No standby report yet — the orchestrator writes one every 15 seconds.</p>;
  const fams = Object.entries(standby.families || {});
  return (
    <div className="cs-plan-tablewrap">
      <table>
        <thead><tr><th>Family</th><th>Runner</th><th>Status</th><th>Job</th><th>Code</th><th>Up</th><th>Jobs</th></tr></thead>
        <tbody>
          {fams.flatMap(([k, f]) => (f.runners?.length ? f.runners : [null]).map((r, i) => (
            <tr key={`${k}-${r?.id || i}`}>
              <td>{k}{i === 0 ? <span className="cs-help"> · target {f.target}/{f.max}</span> : null}</td>
              {r ? (
                <>
                  <td className="live-mono">{String(r.id).slice(0, 8)}</td>
                  <td>{r.retire ? `${r.status} → retiring` : r.status}</td>
                  <td className="live-mono">{r.jobId || '—'}</td>
                  <td className="live-mono">{r.code ? String(r.code).slice(0, 8) : 'baked'}</td>
                  <td>{r.bootAt ? ago(r.bootAt) : '—'}</td>
                  <td>{r.jobsDone}</td>
                </>
              ) : <td colSpan={6} className="cs-help">{f.idle > 0 ? `none running yet (${f.pending} starting)` : 'pool off'}</td>}
            </tr>
          )))}
          {!fams.length && <tr><td colSpan={7} className="cs-help">No families configured.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export function PlaneBoard({ plane, period }) {
  const rows = Object.entries(plane?.byService || {}).sort((a, b) => b[1] - a[1]);
  return (
    <div className="cs-plan-tablewrap">
      <p className="cs-help" style={{ marginTop: 0 }}>{period ? `${period} · ` : ''}{plane ? `${usd(plane.totalUsd)} month to date` : 'No plane cost rollup yet.'}</p>
      <table>
        <thead><tr><th>Service</th><th>MTD</th></tr></thead>
        <tbody>
          {rows.map(([k, v]) => <tr key={k}><td>{k}</td><td>{usd(v)}</td></tr>)}
          {!rows.length && <tr><td colSpan={2} className="cs-help">No service breakdown yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export function ReleaseBoard({ instances = [], pinnedKitRef }) {
  const rows = instances.filter((i) => i.status !== 'terminated');
  return (
    <div className="cs-plan-tablewrap">
      <p className="cs-help" style={{ marginTop: 0 }}>Pinned kit {pinnedKitRef || 'main'}.</p>
      <table>
        <thead><tr><th>App</th><th>Kit</th><th>Pin</th></tr></thead>
        <tbody>
          {rows.map((i) => {
            const ref = i.repo?.kitRef || i.kitRef || '';
            const drift = !!(ref && pinnedKitRef && ref !== pinnedKitRef);
            return (
              <tr key={`${i.orgId}/${i.appId}`}>
                <td>{i.slug}</td>
                <td className="live-mono">{ref ? String(ref).slice(0, 8) : '—'}</td>
                <td>{drift ? 'off the pin' : 'on pin'}</td>
              </tr>
            );
          })}
          {!rows.length && <tr><td colSpan={3} className="cs-help">No instances.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
